export default "/images/vendor/intl-tel-input/build/globe.webp?7fb216c936a98b90918e505af20b71d9";